import { DatastoreInterface } from '@freelancer/datastore/core';
import { UserCalifornianStatus } from './user-californian-statuses.model';
import { UserCalifornianStatusesCollection } from './user-californian-statuses.types';

interface GenerateUserCalifornianStatusesOptions {
  readonly userIds: ReadonlyArray<number>;
}

export async function createUserCalifornianStatuses(
  datastore: DatastoreInterface,
  options: GenerateUserCalifornianStatusesOptions,
) {
  const objects = generateUserCalifornianStatusObjects(options);
  await Promise.all(
    objects.map(object =>
      datastore.createRawDocument<UserCalifornianStatusesCollection>(
        'userCalifornianStatuses',
        object,
      ),
    ),
  );

  return objects;
}

// TODO: Make this toggleable when we begin testing Cali
function generateUserCalifornianStatusObjects({
  userIds,
}: GenerateUserCalifornianStatusesOptions): ReadonlyArray<
  UserCalifornianStatus
> {
  return userIds.map(id => ({
    id: id.toString(),
    ip: '204.236.225.72',
    isUserPotentiallyCalifornian: false,
    isUserCalifornian: false,
  }));
}
